module.exports = __webpack_public_path__ + "static/test-65e1db522bf9bb8ddf58209ebf4741f5.mp4";